import axios from "axios";

export const configureHeaderToIndicateRequestIsAnAjaxOne = () => {
  // set this header so we can detect on the server if this is an ajax request
  axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
};
